import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

Office.onReady(() => {
  const container = document.getElementById("container") ?? document.body;
  createRoot(container).render(<App />);
});
